// ----------------------------------------------------------------------
// <copyright file="Izenda.VerticalLayout.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * VerticalLayout component
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { isNil } from 'lodash/fp';
@observer
export default class VerticalLayout extends Component {
  @observable sizeOfTitle = { height: null };

  componentDidMount() {
    this.sizeOfTitle.height = this.title.clientHeight;
  }

  getContainerSize = () => {
    if (isNil(this.container)) {
      return {};
    }

    return {
      width: this.container.clientWidth,
      height: this.container.clientHeight - this.title.clientHeight
    };
  };

  setContainer = container => {
    this.container = container;
  };

  setTitle = title => {
    this.title = title;
  };

  isDOMTypeElement = (element) => {
    return React.isValidElement(element) && typeof element.type === 'string';
  };

  render() {
    const { children, className } = this.props;
    const containerSize = this.getContainerSize();
    const classes = classnames('u_fullSize', className);

    return (
      <div className={classes} ref={this.setContainer}>
        <div ref={this.setTitle}>{children[0]}</div>

        {!isNil(this.sizeOfTitle.height) && (
          this.isDOMTypeElement(children[1])
            ? (<div style={containerSize}>{React.cloneElement(children[1])}</div>)
            : (<div style={containerSize}>{React.cloneElement(children[1], { containerSize })}</div>)
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.VerticalLayout.js